import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue';

import useBrowserZoom from '../composables/useBrowserZoom';


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldNameLabel',
  props: {
    map: null,
    fieldName: null,
    position: null
  },
  setup(__props: any) {

const props = __props as { map: google.maps.Map; fieldName: string; position: google.maps.LatLng }

let overlayView = new google.maps.OverlayView();


const positionStyle = ref();
const { browserZoom } = useBrowserZoom();

onMounted(() => {
  overlayView = new google.maps.OverlayView();
  overlayView.onAdd = () => null;
  overlayView.draw = () => {
    positionStyle.value = getStyle();
  };
  overlayView.onRemove = () => null;
  overlayView.setMap(props.map);
});

onBeforeUnmount(() => {
  overlayView.setMap(null);
});

function calculatePositionStyle() {
  const point = overlayView.getProjection().fromLatLngToContainerPixel(props.position);
  if (point) {
    return {
      top: `${point.y}px`,
      left: `${point.x}px`,
    };
  }
  return { top: 0, left: 0 };
}

function getFontSize() {
  const zoom = props.map.getZoom();
  const increaseFontSize = browserZoom.value <= 81;
  if (zoom! >= 15) {
    return increaseFontSize ? '14px' : '12px';
  }

  if (zoom! < 15) {
    return increaseFontSize ? '10px' : '9px';
  }

  return increaseFontSize ? '10px' : '9px';
}

function getStyle() {
  return {
    ...calculatePositionStyle(),
    fontSize: getFontSize(),
  };
}

return { __sfc: true,overlayView, props, positionStyle, browserZoom, calculatePositionStyle, getFontSize, getStyle }
}

})